module.exports = __webpack_public_path__ + "static/img/banner.2821846.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/banner.jpg
// module id = PZbl
// module chunks = 0